import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CONTENT_BUILDER_DEPENDENCIES, DefaultPromptBuilder, PageComponent } from '@galaxy/email-ui/builder-v3';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { DynamicVariableService } from '../../email-v2/services/dynamic-variable.service';
import { ImageUploadService } from '@galaxy/email-ui/email-builder/src/services/image-upload.service';
import { TranslateModule } from '@ngx-translate/core';
import { AutomationEmailBuilderService } from './automation-email-builder.service';
import {
  DEFAULT_CONTENT,
  SUPPORTED_BLOCK_TYPES,
  SUPPORTED_SETTINGS,
} from '../../email-v2/services/builder-dependencies.factory';

@Component({
  selector: 'app-automation-email-builder-dialog',
  standalone: true,
  imports: [PageComponent, MatIconButton, MatIcon, TranslateModule, GalaxyPageModule],
  providers: [
    AutomationEmailBuilderService,
    ImageUploadService,
    {
      provide: CONTENT_BUILDER_DEPENDENCIES,
      useFactory: () => {
        const dynamicVariableService = inject(DynamicVariableService);
        const imageUploadService = inject(ImageUploadService);
        const builderService = inject(AutomationEmailBuilderService);
        return {
          dynamicVariableService,
          imageUploadService,
          builderService,
          uploaderService: imageUploadService,
          promptBuilder: new DefaultPromptBuilder(),
          supportedBlockTypes: SUPPORTED_BLOCK_TYPES,
          supportedSettings: SUPPORTED_SETTINGS,
          defaultContent: { ...DEFAULT_CONTENT },
        };
      },
    },
  ],
  templateUrl: './automation-email-builder-dialog.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutomationEmailBuilderDialogComponent {
  private readonly dialogRef =
    inject<MatDialogRef<AutomationEmailBuilderDialogComponent, string | undefined>>(MatDialogRef);
  private readonly builderService = inject(AutomationEmailBuilderService);

  constructor() {
    effect(() => {
      const saved = this.builderService.saved();
      if (saved) {
        this.dialogRef.close(saved.emailId);
      }
    });
  }

  close(): void {
    this.dialogRef.close(undefined);
  }
}
